
// src/components/Layout.jsx
import React from "react";
import Header from "./Header";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <div className="min-h-screen w-full  flex-col flex flex-wrap">

      {/* Sticky Header */}
      <div className=" bg-white shadow">
        <Header />
        <Navbar />
      </div>

      {/* Scrollable Content */}
     <main className="flex-grow p-4">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};


export default Layout;
